module.exports = __webpack_public_path__ + "assets/img/club.d84219fe.jpg";